import { call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import { Auth } from 'aws-amplify'

const authContext = fn => [Auth, fn]

function* login({ email, password }) {
  try {
    console.log('login', email)
    const user = yield call(authContext(Auth.signIn), email, password)
    console.log('user', user)

    if (user.challengeName) {
      yield put({
        type: 'USER_CHALLENGE',
        userChallenge: user.challengeName,
        user,
      })
    } else {
      yield put({ type: 'LOGGED_IN', user, userChallenge: null })
    }
  } catch (e) {
    console.log('login failed', e)
    yield put({ type: 'LOGIN_FAILED', e: e.message ? e.message : e })
  }
}

function* challengeNewPassword({ user, newPassword }) {
  const data = yield call(
    authContext(Auth.completeNewPassword),
    user,
    newPassword,
    {}
  )
  console.log('password changed', data)
}

function* logout() {
  yield call(authContext(Auth.signOut))
  yield put({ type: 'LOGGED_OUT' })
}

function* mySaga() {
  yield takeLatest('LOGIN_REQUESTED', login)
  yield takeLatest('LOGOUT_REQUESTED', logout)
  yield takeLatest('NEW_PASSWORD', challengeNewPassword)
}

export default mySaga



// WEBPACK FOOTER //
// ./src/state/sagas.js